// Turks (tr-TR), householdsApp: zelfde vorm als householdsApp.nl.ts (golf 6b). Wat ontbreekt valt
// terug op het Nederlands (nooit een rauwe sleutel op het scherm).
export const appHouseholdsTr = {
    question: 'Evde kimler yaşıyor?',
    questionBody: 'Böylece size uyanı hazırlarız. Her şeyi sonra değiştirebilirsin, hiçbir şey kaybolmaz.',
    types: {
        family: {
            name: 'Çocuklu aile',
            body: 'Anne babalar ve çocuklar. Takvim, yıldızlı ev işleri, götürüp getirme.',
        },
        two_home: {
            name: 'İki evli aile',
            body: 'Çocuklar kısmen diğer ebeveynle de yaşıyor. Sakin ve tarafsız.',
        },
        couple: {
            name: 'Çift',
            body: 'İki yetişkin. Ortak takvim, alışveriş ve yapılacaklar.',
        },
        solo: {
            name: 'Yalnız',
            body: 'İş, spor ve randevular kontrol altında. Kısa ve net.',
        },
        student: {
            name: 'Öğrenci evi',
            body: 'Adil bir temizlik sırası, alışveriş ve bir mesaj panosu. Koridordaki pano bulaşık sırasının kimde olduğunu bilir.',
        },
        shared: {
            name: 'Ev arkadaşları',
            body: 'Yetişkinlerin paylaştığı bir ev. Adil bir sıra ve koridorda bir pano.',
        },
        cohousing: {
            name: 'Ortak yaşam grubu veya avlu',
            body: 'Kendi evleri ve ortak bir alan. Ortak salon için bir takvim, mesajlar ve kimin temizlediği.',
        },
        senior: {
            name: 'Evde yaşlılar',
            body: 'Kendi evinde bağımsız. Büyük yazı, randevular, hatırlatmalar (ilaçlar dahil) ve hava durumu.',
        },
        care: {
            name: 'Evde yaşlılar, aile takip ediyor',
            body: 'Yalnız yaşayan biri; ailesi uzaktan takip ediyor. Büyük yazı, az düğme.',
        },
    },
    short: {
        family: 'Aile',
        two_home: 'İki evli aile',
        couple: 'Çift',
        solo: 'Yalnız',
        student: 'Öğrenci evi',
        shared: 'Ev arkadaşları',
        cohousing: 'Ortak yaşam grubu',
        senior: 'Evde yaşlılar',
        care: 'Aileyle evde yaşlılar',
    },
    /** Vervolgvraag bij Ouderen thuis (live r1): ja = care (familie kijkt mee), nee = senior. */
    seniorFamilyQuestion: 'Aile uzaktan takip ediyor mu?',
    yes: 'Evet',
    no: 'Hayır',
    laterNote: 'Aynı evde birkaç kuşak mı yaşıyor? Çocuklu aileyi seçin.',
    modulesOn: 'Bunları sizin için açıyoruz',
    modulesOnHint: 'Doğru mu? Her bölümü sonra Ayarlar’dan açıp kapatabilirsin.',
    confirm: 'Doğru, devam',
    settingsTitle: 'Hane türü',
    settingsBody: 'Aile, ev arkadaşları, yalnız …',
    settingsIntro: 'Tür; hangi bölümlerin varsayılan olarak açık olduğunu, uygulamanın görünümünü ve birkaç kelimeyi belirler. Hiçbir şey silinmez.',
    current: 'Şu an seçili',
    choose: 'Başka bir tür seç',
    previewTitle: 'Ne değişiyor?',
    turnsOn: 'Açılıyor',
    turnsOff: 'Kapanıyor',
    turnsOffNote: 'İçindekiler saklanır. Sonra yeniden açarsan her şey yerinde durur.',
    kept: 'Sizin seçtiğiniz gibi kalıyor',
    nothingChanges: 'Bölümler olduğu gibi kalır. Yalnızca görünüm ve birkaç kelime değişir.',
    lookChanges: 'Görünüm de buna uyum sağlar.',
    resetChoices: 'Modüller’deki kendi seçimlerimizi de varsayılana döndür',
    apply: '{name} olarak değiştir',
    cancel: 'Değiştirme',
    toast: 'Haneniz artık: {name}. Hiçbir şey silinmedi.',
    onlyParents: 'Bunu sadece bir yönetici değiştirebilir.',
    words: {
        family: {
            members: 'Aile üyeleri',
            profileTitle: 'Ailenize ne uyar?',
            weatherBody: 'Mont, çizme ya da güneş kremi: çocuklar evden çıkarken söyleriz.',
            adult: 'Ebeveyn',
            tasks: 'Görevler',
            cleaning: 'Temizlik',
            household: 'aile',
            admin: 'Ebeveyn',
        },
        adults: {
            members: 'Burada kim yaşıyor',
            profileTitle: 'Size ne uyar?',
            weatherBody: 'Mont, şemsiye ya da güneş kremi: tam evden çıkmadan önce söyleriz.',
            adult: 'Yetişkin',
            tasks: 'Görevler',
            cleaning: 'Temizlik',
            household: 'hane',
            admin: 'Yönetici',
        },
        shared: {
            members: 'Ev arkadaşları',
            profileTitle: 'Evinize ne uyar?',
            weatherBody: 'Mont, şemsiye ya da güneş kremi: koridordaki panoda, tam evden çıkmadan önce.',
            adult: 'Ev arkadaşı',
            tasks: 'Görevler',
            cleaning: 'Temizlik',
            household: 'ev',
            admin: 'Yönetici',
        },
        care: {
            members: 'Aile',
            profileTitle: 'Size ne uyar?',
            weatherBody: 'Mont, şemsiye ya da güneş kremi: tam evden çıkmadan önce söyleriz.',
            adult: 'Yetişkin',
            tasks: 'Görevler',
            cleaning: 'Temizlik',
            household: 'hane',
            admin: 'Bakım veren',
        },
    },
    greetingHouse: 'Seni görmek güzel',
    wizardRotationTitle: 'Adil bir çizelge',
    wizardRotationBody: 'Mutfak, banyo, koridor, çöp ve bulaşık her hafta döner; her akşam da başka biri yemek pişirir. Koridordaki pano sıranın kimde olduğunu gösterir.',
    wizardAdultsTitle: 'Başlamaya hazır',
    wizardAdultsBody: 'Randevularını takvime ekle ve yapılacakları takip et. Gerektiğinde telefonun sana haber verir.',
    wizardMembersShared: 'Evde kimler yaşıyor? Herkese daha sonra kendi girişini verebilirsin.',
    /** Golf 6b fixer r1: woorden bij "alleen" (enkelvoud; de rest van de volwassen set blijft). */
    soloWords: {
        members: 'Kimler dahil',
        profileTitle: 'Sana ne uygun?',
        profileBody: 'Mutfak, inanç ve yemeği seç, böylece sana daha uygun olanı görürsün. Zorunlu değil.',
    },
    /** Live r1: woorden bij een woongroep of hofje (bovenop de volwassen set). */
    cohousingWords: {
        members: 'Sakinler',
        profileTitle: 'Yaşam grubunuza ne uyar?',
        household: 'yaşam grubu',
        adult: 'Sakin',
    },
    /** Golf 6b fixer r1: toon per soort (geen kindertaal bij volwassen soorten; gezin = standaard). */
    tone: {
        adults: {
            membersTitle: 'Burada kimler yaşıyor',
            membersIntro: 'Panoda olan herkes. Herkesin rengini her yerde görürsün.',
            membersAdd: 'Kişi',
            membersAddLong: 'Kişi ekle',
            membersNew: 'Yeni kişi',
            namePlaceholder: 'Örneğin Noor',
            face: 'Simge',
            kidLockTitle: 'Tablet kilidi',
            kidLockBody: 'Biri tablette bir şeyi işaretlemeden önce PIN kodu. Varsayılan olarak kapalı.',
            exportAll: 'Herkes',
            devicesIntro: 'Panonuzun çalıştığı tabletler.',
            library: 'Görev fikirleri',
            libraryIntro: 'Bir görev ve kimin için olduğunu seç.',
            wizardMembersTitle: 'Kimler yaşıyor?',
            wizardMembersBody: 'Herkese kendi rengini ver. Bu rengi her yerde görürsün.',
            noTasksTitle: 'Bugün görev yok',
            noTasksBody: 'Her şey tamam.',
            tasksWidget: 'Bugünkü görevler',
            tasksAll: 'Tüm görevler',
            tasksEmptyBody: 'Küçük bir şeyle başla, örneğin çamaşır ya da bitkileri sulamak.',
            exportBody: 'Takvimi .ics dosyası olarak indir, herkes için ya da kişi başına.',
            dataBody: 'Verilerinizin bir kopyası dosya olarak (JSON), {profile} bölümündeki seçimler de dahil. Önce şifrenle onaylarsın.',
            dataAll: 'Hepsi',
            privacyEntryBody: 'Her şeyi indir, birini çıkar ya da panoyu sil.',
            approvalHint: 'Görev tamamlandı sayılmadan önce başka biri kontrol eder.',
            supportIntro: 'Yardıma mı ihtiyacın var? AMUMIN bir süreliğine sadece okuyarak bakabilir. Ne kadar süreceğine sen karar verirsin ve her yönetici bunu istediği an durdurabilir.',
            supportOff: 'Kapalı. AMUMIN’den kimse panonuzu göremez.',
            supportSees: 'AMUMIN o zaman şunları görür: panodaki herkesin adı, bugünün ve sonraki 6 günün randevu başlıkları (bir başlıkta Diş hekimi gibi bir şey yazabilir; cami veya kilise gibi inanç simgeli randevular hariç), odalar ve tabletler. Görmez: inanç, sağlık, okul, e-posta adresleri veya fotoğraflar. Her bakış aşağıda listelenir.',
        },
        solo: {
            membersTitle: 'Kimler dahil',
            membersIntro: 'Sen ve sonra eklediğin kişiler. Rengini her yerde görürsün.',
            membersAdd: 'Kişi',
            membersAddLong: 'Kişi ekle',
            membersNew: 'Yeni kişi',
            namePlaceholder: 'Örneğin Noor',
            face: 'Simge',
            kidLockTitle: 'Tablet kilidi',
            kidLockBody: 'Biri tablette bir şeyi işaretlemeden önce PIN kodu. Varsayılan olarak kapalı.',
            exportAll: 'Her şey',
            devicesIntro: 'Panonun çalıştığı tabletler.',
            library: 'Görev fikirleri',
            libraryIntro: 'Sık yaptığın bir görev seç.',
            wizardMembersTitle: 'Başka biri var mı?',
            wizardMembersBody: 'Sen zaten panodasın. Örneğin ortak randevular için başka biri de olacak mı? Buradan ya da daha sonra ekle.',
            noTasksTitle: 'Bugün görev yok',
            noTasksBody: 'Her şey tamam.',
            tasksWidget: 'Bugünkü görevler',
            tasksAll: 'Tüm görevler',
            tasksEmptyBody: 'Küçük bir şeyle başla, örneğin çamaşır ya da bitkileri sulamak.',
            exportBody: 'Takvimi .ics dosyası olarak indir, herkes için ya da kişi başına.',
            dataBody: 'Verilerinizin bir kopyası dosya olarak (JSON), {profile} bölümündeki seçimler de dahil. Önce şifrenle onaylarsın.',
            dataAll: 'Hepsi',
            privacyEntryBody: 'Her şeyi indir, birini çıkar ya da panoyu sil.',
            approvalHint: 'Görev tamamlandı sayılmadan önce kendin kontrol edersin.',
            supportIntro: 'Yardıma mı ihtiyacın var? AMUMIN bir süreliğine sadece okuyarak bakabilir. Ne kadar süreceğine sen karar verirsin ve istediğin an durdurabilirsin.',
            supportOff: 'Kapalı. AMUMIN’den kimse panonu göremez.',
            supportSees: 'AMUMIN o zaman şunları görür: panodaki herkesin adı, bugünün ve sonraki 6 günün randevu başlıkları (bir başlıkta Diş hekimi gibi bir şey yazabilir; cami veya kilise gibi inanç simgeli randevular hariç), odalar ve tabletler. Görmez: inanç, sağlık, okul, e-posta adresleri veya fotoğraflar. Her bakış aşağıda listelenir.',
        },
        shared: {
            membersTitle: 'Ev arkadaşları',
            membersIntro: 'Evde yaşayan herkes. Herkesin rengini her yerde görürsün.',
            membersAdd: 'Ev arkadaşı',
            membersAddLong: 'Ev arkadaşı ekle',
            membersNew: 'Yeni ev arkadaşı',
            namePlaceholder: 'Örneğin Sanne',
            face: 'Simge',
            kidLockTitle: 'Tablet kilidi',
            kidLockBody: 'Biri koridordaki tablette bir şeyi işaretlemeden önce PIN kodu. Varsayılan olarak kapalı.',
            exportAll: 'Tüm ev',
            devicesIntro: 'Evdeki panonun çalıştığı tabletler.',
            library: 'Görev fikirleri',
            libraryIntro: 'Bir görev ve kimin yapacağını seç.',
            wizardMembersTitle: 'Kimler yaşıyor?',
            wizardMembersBody: 'Evde kimler yaşıyor? Herkese daha sonra kendi girişini verebilirsin.',
            noTasksTitle: 'Bugün görev yok',
            noTasksBody: 'Kimin ne yaptığını nöbet çizelgesinde gör.',
            tasksWidget: 'Bugünkü görevler',
            tasksAll: 'Tüm görevler',
            tasksEmptyBody: 'Küçük bir şeyle başla, örneğin çöpü dışarı çıkarmak.',
            exportBody: 'Takvimi .ics dosyası olarak indir, herkes için ya da kişi başına.',
            dataBody: 'Verilerinizin bir kopyası dosya olarak (JSON), {profile} bölümündeki seçimler de dahil. Önce şifrenle onaylarsın.',
            dataAll: 'Tüm ev',
            privacyEntryBody: 'Her şeyi indir, birini çıkar ya da panoyu sil.',
            approvalHint: 'Görev tamamlandı sayılmadan önce bir ev arkadaşı kontrol eder.',
            supportIntro: 'Yardıma mı ihtiyacın var? AMUMIN bir süreliğine sadece okuyarak bakabilir. Ne kadar süreceğine sen karar verirsin ve evdeki her yönetici bunu istediği an durdurabilir.',
            supportOff: 'Kapalı. AMUMIN’den kimse evinizin panosunu göremez.',
            supportSees: 'AMUMIN o zaman şunları görür: panodaki herkesin adı, bugünün ve sonraki 6 günün randevu başlıkları (bir başlıkta Diş hekimi gibi bir şey yazabilir; cami veya kilise gibi inanç simgeli randevular hariç), odalar ve tabletler. Görmez: inanç, sağlık, okul, e-posta adresleri veya fotoğraflar. Her bakış aşağıda listelenir.',
        },
        care: {
            membersTitle: 'Aile',
            membersIntro: 'Yardım eden ya da panoda olan herkes. Herkesin rengini her yerde görürsün.',
            membersAdd: 'Kişi',
            membersAddLong: 'Kişi ekle',
            membersNew: 'Yeni kişi',
            namePlaceholder: 'Örneğin Anja',
            face: 'Simge',
            kidLockTitle: 'Tablet kilidi',
            kidLockBody: 'Biri tablette bir şeyi işaretlemeden önce PIN kodu. Varsayılan olarak kapalı.',
            exportAll: 'Herkes',
            devicesIntro: 'Panonun çalıştığı tabletler.',
            library: 'Görev fikirleri',
            libraryIntro: 'Bir görev ve kimin için olduğunu seç.',
            wizardMembersTitle: 'Kimler yardım ediyor?',
            wizardMembersBody: 'Yardım eden ya da panoda olması gereken herkesi ekle. Herkes kendi rengini alır.',
            noTasksTitle: 'Bugün görev yok',
            noTasksBody: 'Her şey tamam.',
            tasksWidget: 'Bugünkü görevler',
            tasksAll: 'Tüm görevler',
            tasksEmptyBody: 'Küçük bir şeyle başla, örneğin ilaçlar ya da alışveriş.',
            exportBody: 'Takvimi .ics dosyası olarak indir, herkes için ya da kişi başına.',
            dataBody: 'Verilerinizin bir kopyası dosya olarak (JSON), {profile} bölümündeki seçimler de dahil. Önce şifrenle onaylarsın.',
            dataAll: 'Hepsi',
            privacyEntryBody: 'Her şeyi indir, birini çıkar ya da panoyu sil.',
            approvalHint: 'Görev tamamlandı sayılmadan önce bir yönetici kontrol eder.',
            supportIntro: 'Yardıma mı ihtiyacın var? AMUMIN bir süreliğine sadece okuyarak bakabilir. Ne kadar süreceğine sen karar verirsin ve her yönetici bunu istediği an durdurabilir.',
            supportOff: 'Kapalı. AMUMIN’den kimse panonuzu göremez.',
            supportSees: 'AMUMIN o zaman şunları görür: panodaki herkesin adı, bugünün ve sonraki 6 günün randevu başlıkları (bir başlıkta Diş hekimi gibi bir şey yazabilir; cami veya kilise gibi inanç simgeli randevular hariç), odalar ve tabletler. Görmez: inanç, sağlık, okul, e-posta adresleri veya fotoğraflar. Her bakış aşağıda listelenir.',
        },
    },
    rotation: {
        title: 'Nöbet çizelgesi',
        intro: 'İşler adilce döner: sırası gelen, sıranın sonuna geçer. Uzakta olan bir sırayı atlar ve sonra yeniden ilk sıradadır.',
        thisWeek: 'Bu hafta',
        today: 'Bugün',
        nextUp: 'Sonra',
        weekOf: '{date} haftası',
        nobody: 'Kimse katılmıyor',
        done: '{name} yaptı',
        notYet: 'Henüz yapılmadı',
        swapped: 'Takas edildi',
        skipped: '{name} uzakta',
        swap: 'Takas et',
        swapTitle: '{period} {duty} işini kim yapıyor?',
        swapPeriodWeek: 'bu hafta',
        swapPeriodDay: 'bugün',
        swapUndo: 'Takası geri al',
        swapSaved: '{duty} işini {name} yapıyor',
        swapRemoved: 'Takas geri alındı',
        away: 'Uzakta',
        awayTitle: 'Biri bir süreliğine uzakta',
        awayBody: 'Tatilde ya da iş için uzakta mı? Bir sırayı atlar ve sonra yeniden ilk sıradadır.',
        awayWho: 'Kim',
        awayFrom: 'Başlangıç',
        awayTo: 'Bitiş (dahil)',
        awayAdd: 'Uzakta olarak işaretle',
        awayRemove: 'Evde',
        awayItem: '{name}: {from} – {to}',
        awaySaved: '{name} uzakta olarak işaretlendi',
        awayRemoved: '{name} yeniden evde',
        awayInvalid: 'Bitiş tarihi başlangıç tarihinden önce.',
        empty: 'Henüz nöbet çizelgesi yok',
        emptyBody: 'Mutfak, banyo, koridor, çöp, bulaşık ve yemekle bir çizelge oluştur. Sonra Temizlik’te iş ekleyip çıkarabilirsin.',
        setup: 'Nöbet çizelgesini oluştur',
        setupDone: 'Çizelgede {count} iş var',
        setupNothing: 'Bu işler zaten çizelgede',
        weekly: 'Her hafta',
        daily: 'Her gün',
        others: 'Diğer işler',
        othersBody: 'Temizlik’teki henüz dönmeyen işler.',
        makeWeekly: 'Her hafta döndür',
        makeDaily: 'Her gün döndür',
        stopRotating: 'Döndürmeyi bırak',
        rotatingOn: '{duty} artık dönüyor',
        rotatingOff: '{duty} artık dönmüyor',
        onBoard: 'Koridordaki pano bu hafta sıranın kimde olduğunu gösterir. Orada bir dokunuşla işaretlenir.',
        duties: {
            kitchen: 'Mutfak',
            bathroom: 'Banyo',
            hallway: 'Koridor ve merdiven',
            trash: 'Çöp',
            dishes: 'Bulaşık',
            cooking: 'Yemek',
        },
    },
};
//# sourceMappingURL=householdsApp.tr.js.map